import { render, staticRenderFns } from "./meetingSettingsModal.vue?vue&type=template&id=20920b00&scoped=true"
import script from "./meetingSettingsModal.vue?vue&type=script&lang=js"
export * from "./meetingSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./meetingSettingsModal.vue?vue&type=style&index=0&id=20920b00&prod&land=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20920b00",
  null
  
)

export default component.exports